module.exports = new __parcel__URL__("stealth.b04bdad4.png").toString();